export enum FirebasePushNotificationType {
    ClientBuyOrderStatusChangedNotification = "ClientBuyOrderStatusChangedNotification",
    ClientSellOrderStatusChangedNotification = "ClientSellOrderStatusChangedNotification",
    ClientTransferCompletedNotification = "ClientTransferCompletedNotification",
    ClientNewIncomeNotification = "ClientNewIncomeNotification",
    ClientNewChatMessageNotification = "ClientNewChatMessageNotification"
}